import(/* webpackMode: "eager" */ "/var/www/sqxbonds-UI/apps/node_modules/next/dist/client/app-dir/link.js");
